export default [
  {
    title: 'Home',
    icon: 'HomeIcon',
    route: 'home',
    resource: 'pages',
    action: 'read',
  },
]
